import { useState } from 'react';
import {
	FlexColumnDiv,
	StepperContentBodyDiv,
}
	from '../../styledComponents/Components.styles';
import { textHints } from '../../../utilities/hintText';
import { TextField } from '../formFields/TextField';
import { useDataContext } from '../../DataProvider/DataContext';
import { MultiValueTextField } from '../formFields/MultiValuesTextField';


/**
 * 
 * @param componentName: name of the component
 * @param componentOnChange: function to call when the component changes
 * @returns a list of preassembly images components
 */
export default function PreAssemblyImage({
	preassemblyImage,
	setPreassemblyImage,
	preassemblyImageErrors,
	setPreassemblyImageErrors }) {

	const handleTextFieldChange = (event) => {
		const fieldName = event.target.name;
		const fieldValue = event.target.value;

		let updatedData = {...preassemblyImage};
		updatedData[fieldName] = fieldValue;
		setPreassemblyImage(updatedData);

		const isRequired = event.target.required;
		if(isRequired){
			const validationError = fieldValue === '' ? 'This field is required' : '';
			const validationFieldName = `${fieldName}ValidationError`;

			let updatedErrors = {...preassemblyImageErrors};
			updatedErrors[validationFieldName] = validationError;
			setPreassemblyImageErrors(updatedErrors);
		}
	}


	const handlePreassemblyImageUrlChange = (e) =>{
        let value = e.target.value;
        let filename = value.split("/");
        filename = filename[filename.length -1];
        let name, version = "";
		const updatedPreassemblyImage = structuredClone(preassemblyImage);


        // if "CNR_" is present, split by that instead of using the version.
        if (filename.search("CNR_") !== -1) {
            [name, version] = filename.split("CNR_");
        }
        else{
            // else if d.d.d is found, split by that

            //TODO: change this to fetch from schema when the loading screen is implemented
            const versionPattern =  "(0|[1-9]\\d*)\\.(0|[1-9]\\d*)\\.(0|[1-9]\\d*)(-((0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*)(\\.(0|[1-9]\\d*|\\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(\\+([0-9a-zA-Z-]+(\\.[0-9a-zA-Z-]+)*))?";

            // search for first instance of d.d.d
            let versionLocation = filename.search(versionPattern);

            if(versionLocation !== -1){
                // 'versionLocation-1' to shave off the separating character, be it '_' or '-'
                    // This means it is always expecting a separator of some kind. May need to change.
                name = filename.substring(0, versionLocation-1);
                version = filename.substring(versionLocation);
            }
        }

		if (name !== "" && version !== ""){
            // only validate if they are being changed
            updatedPreassemblyImage["preassemblyImageName"] = name;
            updatedPreassemblyImage["preassemblyImageVersion"] = version.replace('.tar.gz', '').replace('.tgz', '');
        }

        updatedPreassemblyImage["preassemblyImageUrl"] = value.replace(/\s+/g, '');
        setPreassemblyImage(updatedPreassemblyImage);
    }


	return (
		<FlexColumnDiv style={{marginLeft: '20px'}}>

		  <StepperContentBodyDiv style={{width: '1200px', alignSelf: 'center', gap: '20px'}}>
		
			<FlexColumnDiv>
			<TextField
				label="Image Name"
				value={preassemblyImage.preassemblyImageName}
				placeholder="Enter name"
				onChange={handleTextFieldChange}
				textHint={textHints.imageName}
				errorMessage={preassemblyImageErrors.preassemblyImageNameValidationError}
				idLabel="preassemblyImageName"
				idInput="preassemblyImageName"
				idError="preassemblyImageName_error"
				nameInput="preassemblyImageName"
				pathToField={"preassemblyImage.preassemblyImageName"}
				stylingVariant='body'
			/>

			<TextField
				label="Image Version"
				value={preassemblyImage.preassemblyImageVersion}
				placeholder="Enter version"
				onChange={handleTextFieldChange}
				textHint={textHints.imageVersion}
				errorMessage={preassemblyImageErrors.preassemblyImageVersionValidationError}
				idLabel="preassemblyImageVersion"
				idInput="preassemblyImageVersion"
				idError="preassemblyImageVersion_error"
				nameInput="preassemblyImageVersion"
				pathToField={"preassemblyImage.preassemblyImageVersion"}
				stylingVariant='body'
			/>
			</FlexColumnDiv>

			<FlexColumnDiv>
			<TextField
				label="Image URL"
				value={preassemblyImage.preassemblyImageUrl}
				// required={true}
				placeholder="Enter URL"
				onChange={handlePreassemblyImageUrlChange}
				textHint={textHints.swInstructionArtifactURL}
				errorMessage={preassemblyImageErrors.preassemblyImageUrlValidationError}
				idInput="preassemblyImageUrl"
				idError="preassemblyImageUrl_error"
				nameInput="preassemblyImageUrl"
				pathToField={"preassemblyImage.preassemblyImageUrl"}
				stylingVariant='body'
			/>



			{/* f111coreAssemblyNum */}
			<MultiValueTextField
				label="F111 Core Assembly Number"
				value={preassemblyImage.f111coreAssemblyNum.map(value => ({ label: value, value: value }))}
				placeholder="Enter F111"
				onChange={(selectedOptions) => {
					const updatedImage = structuredClone(preassemblyImage);
					const selectedValues = selectedOptions.map(option => option.value);
					updatedImage.f111coreAssemblyNum = selectedValues;
					setPreassemblyImage(updatedImage);
				}}
				textHint={textHints.f111coreAssemblyNum}
				idLabel="f111coreAssemblyNum"
				idInput="f111coreAssemblyNum"
				nameInput="f111coreAssemblyNum"
				pathToField={"preassemblyImage.f111coreAssemblyNum"}
				stylingVariant='body'
			/>
			</FlexColumnDiv>

			</StepperContentBodyDiv>
		</FlexColumnDiv>
	);
}

